import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
// Models
import mDevice from 'models/device';
import mOperator from 'models/operator';
// Custom
import { operatorDataShape } from 'constants/PropTypesShapes';
import AppIcon from 'components/icons/AppIcon';
import InformationItem from './InformationItem';

export const AddressItem = (props) => <InformationItem {...props} icon="itemAddress" label={<LocalizedMessage id="field.address" />} gender="female" />;
export const CallNumberItem = (props) => <InformationItem {...props} icon="itemPhone" label={<LocalizedMessage id="field.callNumber" />} gender="male" />;
export const CapacityItem = (props) => <InformationItem {...props} icon="itemCapacity" label={<LocalizedMessage id="field.capacity" />} gender="female" />;
export const CarparkItem = (props) => <InformationItem {...props} icon="itemParking" label={<LocalizedMessage id="field.carpark" />} />;
export const CommentsItem = (props) => <InformationItem {...props} icon="itemComments" label={<LocalizedMessage id="field.comments" />} gender="male" />;
export const CommitDateItem = (props) => <InformationItem {...props} icon="itemDate" label={<LocalizedMessage id="field.commitDate" />} gender="female" />;
export const ContactItem = (props) => <InformationItem {...props} icon="itemContact" label={<LocalizedMessage id="field.contact" />} gender="male" />;
export const CreationDateItem = (props) => <InformationItem {...props} icon="itemDate" label={<LocalizedMessage id="field.creationDate" />} gender="female" />;
export const CustomerItem = (props) => <InformationItem {...props} icon="itemCustomer" label={<LocalizedMessage id="field.customer" />} gender="male" />;
export const DateItem = (props) => <InformationItem {...props} icon="itemDate" label={<LocalizedMessage id="field.date" />} gender="female" />;
export const DateCreationItem = (props) => <InformationItem {...props} icon="itemDateCreation" label={<LocalizedMessage id="field.beginDate" />} gender="female" />;
export const DateBeginItem = (props) => <InformationItem {...props} icon="itemDateBegin" label={<LocalizedMessage id="field.beginDate" />} gender="female" />;
export const DateEndItem = (props) => <InformationItem {...props} icon="itemDateEnd" label={<LocalizedMessage id="field.endDate" />} gender="female" />;
export const DateEntryItem = (props) => <InformationItem {...props} icon="itemDateBegin" label={<LocalizedMessage id="field.entryDate" />} gender="female" />;
export const DeviceSerialItem = (props) => <InformationItem {...props} icon="itemDevice" label={<LocalizedMessage id="field.serial" />} gender="female" />;
export const EmailItem = (props) => <InformationItem {...props} icon="itemEmail" label={<LocalizedMessage id="field.email" />} gender="male" />;
export const GroupItem = (props) => <InformationItem {...props} icon="itemGroup" label={<LocalizedMessage id="field.group" />} gender="male" />;
export const IccidItem = (props) => <InformationItem {...props} icon="itemSimcard" label={<LocalizedMessage id="field.iccid" />} gender="male" />;
export const InstallationAddressItem = (props) => <InformationItem {...props} icon="itemAddress" label={<LocalizedMessage id="field.installationAddress" />} gender="female" />;
export const InstallationDateItem = (props) => <InformationItem {...props} icon="itemDate" label={<LocalizedMessage id="field.installationDate" />} gender="female" />;
export const IpAddressItem = (props) => <InformationItem {...props} icon="itemIpAddress" label={<LocalizedMessage id="field.ipAddress" />} gender="female" />;
export const LastComDateItem = (props) => <InformationItem {...props} icon="itemLastComDate" label={<LocalizedMessage id="field.lastComDate" />} gender="female" />;
export const ParkingItem = (props) => <InformationItem {...props} icon="itemParking" label={<LocalizedMessage id="field.parking" />} gender="male" />;
export const PhoneNumberItem = (props) => <InformationItem {...props} icon="itemPhone" label={<LocalizedMessage id="field.phoneNumber" />} gender="male" />;
export const PlanningItem = (props) => <InformationItem {...props} icon="itemPlanning" label={<LocalizedMessage id="field.planning" />} gender="male" />;
export const SpaceNumberItem = (props) => <InformationItem {...props} icon="itemParking" label={<LocalizedMessage id="field.spaceNumber" />} gender="male" />;
export const SpacesQuantityItem = (props) => <InformationItem {...props} icon="itemCarInfo" label={<LocalizedMessage id="field.spacesQuantity" />} gender="female" />;
export const StatusItem = (props) => <InformationItem {...props} label={<LocalizedMessage id="field.status" />} gender="male" />;
export const SuccessConditionItem = (props) => <InformationItem {...props} icon="itemSuccessCond" label={<LocalizedMessage id="field.successCondition" />} gender="female" />;
export const TimeItem = (props) => <InformationItem {...props} icon="itemHour" label={<LocalizedMessage id="field.date" />} gender="female" />;
export const UserItem = (props) => <InformationItem {...props} icon="itemUser" gender="male" />;
export const VehicleItem = (props) => <InformationItem {...props} icon="itemVehicle" gender="male" />;
export const ParkingTypeItem = (props) => <InformationItem {...props} icon="itemParking" gender="male" />;

// ----- Boolean Information
export const InfoItem = ({ checked, ...otherProps }) => <InformationItem {...otherProps} icon={checked ? 'checkActive' : 'checkInactive'} gender="male" />;

InfoItem.propTypes = {
  checked: PropTypes.bool.isRequired,
};

// ----- Netowrk specific items
// Access technology
export const NetworkAccessTechnologyItem = ({ networkAccessTechnology, ...props }) => {
  const { icon: networkAccessTechnologyIcon } = mDevice.networkAccessTechnology(networkAccessTechnology) || { icon: 'itemNothing' };

  return (
    <InformationItem
      icon={networkAccessTechnologyIcon}
      label={<LocalizedMessage id="field.networkAccessTechnology" />}
      value={networkAccessTechnology}
      gender="female"
      {...props}
    />
  );
};

NetworkAccessTechnologyItem.propTypes = {
  networkAccessTechnology: PropTypes.string,
};

NetworkAccessTechnologyItem.defaultProps = {
  networkAccessTechnology: null,
};

// Level
export const NetworkLevelItem = ({
  networkLevel, networkAccessTechnology, light, ...props
}) => {
  const { icon, color } = mDevice.networkLevelIcon(networkLevel);
  const { icon: networkAccessTechnologyIcon } = mDevice.networkAccessTechnology(networkAccessTechnology) || {};

  return (
    <InformationItem
      light={light}
      icon={icon}
      iconColor={color}
      label={<LocalizedMessage id="field.networkLevel" />}
      value={!_isNil(networkLevel) ? `${networkLevel}/5` : null}
      rightIcon={networkAccessTechnologyIcon && <AppIcon id={networkAccessTechnologyIcon} defaultColor />}
      gender="male"
      {...props}
    />
  );
};

NetworkLevelItem.propTypes = {
  networkLevel: PropTypes.number,
  networkAccessTechnology: PropTypes.string,
  light: PropTypes.bool,
};

NetworkLevelItem.defaultProps = {
  networkLevel: null,
  networkAccessTechnology: null,
  light: false,
};

// Operator
export const NetworkOperatorItem = ({ networkOperator, light, ...props }) => (
  <InformationItem
    light={light}
    icon="itemNetworkOperator"
    label={<LocalizedMessage id="field.operator" />}
    value={networkOperator ? mOperator.desc(networkOperator) : null}
    gender="male"
    {...props}
  />
);

NetworkOperatorItem.propTypes = {
  networkOperator: operatorDataShape,
  light: PropTypes.bool,
};

NetworkOperatorItem.defaultProps = {
  networkOperator: null,
  light: false,
};



// WEBPACK FOOTER //
// ./components/items/InformationItems.js